<div class="mobile-nav-overlay d-lg-none" [ngClass]="{ 'open' : isMobileNavOpen, 'close' : !isMobileNavOpen }">

    <nav class="mobile-nav d-lg-none">

        <ul>

            <div class="d-flex justify-content-end p-3">
                <button *ngIf="isMobileNavOpen" type="button" class="mobile-nav-toggle" (click)="clickMobileNav()">
                    <i class="fa fa-times text-white"></i>
                </button>
            </div>

            <li *ngFor="let menu of data.MENUS"
                [ngClass]="{ 'drop-down' : menu.SUBMENUS != null, 'active' : validaMenu(menu.CODIGO) }">

                <a *ngIf="menu.SUBMENUS == null" class="{{ menu.COLOR }}" [routerLink]="[ menu.URL ] | localize"
                    (click)="clickMobileNav()" [hidden]="menu.HIDDEN == 'true'">{{ menu.TITULO }}</a>

                <a *ngIf="menu.SUBMENUS != null" class="{{ menu.COLOR }}" (click)="clickMobileMenu(menu.CODIGO)"
                    [hidden]="menu.HIDDEN == 'true'">{{ menu.TITULO }}<i class="fas fa-angle-down ml-2"></i></a>

                <ul *ngIf="menu.SUBMENUS != null"
                    [ngClass]="{ 'open' : isMobileSubMenuOpen && (menuSubSelecionado === menu.CODIGO), 'close' : !isMobileSubMenuOpen || (menuSubSelecionado !== menu.CODIGO) }">
                    <li *ngFor="let submenu of menu.SUBMENUS"
                        [ngClass]="{'active' : validaSubMenu(menu.CODIGO, submenu.CODIGO) }"
                        [hidden]="submenu.HIDDEN == 'true'">
                        <a [routerLink]="[ submenu.URL ] | localize" (click)="clickMobileNav()">{{ submenu.TITULO }}</a>
                    </li>
                </ul>

            </li>

            <li>
                <a href="http://blog.totaldocs.com" target="_blank"><span>{{ data.BLOG }}</span></a>
            </li>

        </ul>
    
    </nav>

</div>

<div id="header" [ngClass]="{ 'header-scrolled' : isScrolled }">

    <div class="header-top">
        <div class="container d-flex justify-content-end align-items-center pt-2 pb-2">
            <button class="btn btn-sm btn-primary mr-4" [routerLink]="[ data.TESTE_GRATIS.URL ] | localize">
                {{ data.TESTE_GRATIS.TEXTO }}
            </button>
            <nav class="main-nav idioma ml-2">
                <ul>
                    <li class="drop-down">
                        <a class="p-0">
                            <div class="d-flex align-items-center">
                                <i class="flag-icon {{ idiomaSelecionado.FLAG }}"></i>
                                <span class="ml-2 mr-2">{{ idiomaSelecionado.TITULO }}</span>
                                <i class="fas fa-angle-down text-info"></i>
                            </div>
                        </a>
                        <ul>
                            <li *ngFor="let idioma of idiomas">
                                <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO"
                                    (click)="alterarIdioma(idioma.CODIGO)"><i
                                        class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </div>

    <div class="container pt-3 pb-3">

        <nav class="navbar main-nav">

            <div class="logo" [routerLink]="[ data.URL_HOME ] | localize">
                <img [src]="logoSrc">
            </div>

            <div class="d-flex justify-content-end align-items-center d-lg-none">
                <button class="btn btn-outline-info mr-2 p-2" [routerLink]="[ data.URL_LOGIN ] | localize">
                    {{data.LOGIN }}
                </button>
                
                <button *ngIf="!isMobileNavOpen" type="button" class="mobile-nav-toggle d-lg-none"
                    (click)="clickMobileNav()">
                    <i class="fa fa-bars"></i>
                </button>
            </div>

            <ul class="d-none d-lg-flex justify-content-end align-items-center">

                <li *ngFor="let menu of data.MENUS"
                    [ngClass]="{ 'drop-down' : menu.SUBMENUS != null, 'active' : validaMenu(menu.CODIGO) }" class="mr-2">

                    <a *ngIf="menu.SUBMENUS == null" class="{{ menu.COLOR }}" [routerLink]="[ menu.URL ] | localize"
                        [hidden]="menu.HIDDEN == 'true'">{{ menu.TITULO }}</a>

                    <a *ngIf="menu.SUBMENUS != null" class="{{ menu.COLOR }}" [hidden]="menu.HIDDEN == 'true'">{{
                        menu.TITULO }}<i class="fas fa-angle-down text-primary ml-2"></i></a>

                    <ul *ngIf="menu.SUBMENUS != null">
                        <li *ngFor="let submenu of menu.SUBMENUS"
                            [ngClass]="{'active' : validaSubMenu(menu.CODIGO, submenu.CODIGO) }"
                            [hidden]="submenu.HIDDEN == 'true'">
                            <a [routerLink]="[ submenu.URL ] | localize">{{ submenu.TITULO }}</a>
                        </li>
                    </ul>

                </li>

                <li class="mr-2">
                    <a href="http://blog.totaldocs.com" target="_blank"><span>{{ data.BLOG }}</span></a>
                </li>

                <li class="ml-2">
                    <button class="btn btn-outline-info p-2" [routerLink]="[ data.URL_LOGIN ] | localize">
                        <i class="fas fa-sign-in-alt mr-2"></i>{{data.LOGIN }}
                    </button>
                </li>

            </ul>

        </nav>

    </div>

</div>